import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { healthSummarySchema } from 'Schemas/schemas';

import { getEntities } from './common';

export const getHealthSummaryData = (entities, id) => (id && entities.healthSummaries)
  ? denormalize(id, healthSummarySchema, entities) : undefined;

export const getHealthSummaryById = createSelector(
  [getEntities, (state, id) => id],
  getHealthSummaryData,
);
